<template>
  <div class="main print-no-padding">
    <h2 class="is-print-hide title-area">
      <span class="main-title">禁用门店</span>
      <div class="handler-area"></div>
    </h2>
    <breadcrumb firstName="门店管理"></breadcrumb>
    <div class="list-content">
      <disabledTable :tableData="prescriptionRes.data" @delItem="delItem"></disabledTable>
      <div class="footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="12"
          layout="prev, pager, next, total, jumper"
          :total="prescriptionRes.totalCount"
          class="is-print-hide common-el-pagination"
        ></el-pagination>
        <div class="sureJump global_common_button_goast">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb';
import disabledTable from '@/components/shopManagement/disabledTable';
import { Button, Pagination } from 'element-ui';
import Vue from 'vue';
import Constant from '@/lib/constant';

const baseRole = Constant.RoleList;
Vue.use(Button);
Vue.use(Pagination);
export default {
  name: 'disabledShop',

  data() {
    return {
      selectIds: '',
      currentPage: 1,
      prescriptionRes: {},
      searchData: {}
    };
  },
  components: {
    disabledTable,
    breadcrumb
  },
  created() {
    let params = {
      pageNo: this.currentPage,
      pageSize: Constant.pageSize,
      status: '',
      isDelete: 1
    };
    this.fetchList(params);
  },
  activated() {
    // console.log(this.$route);
  },
  watch: {},
  methods: {
    delItem(id) {
      let { data } = this.prescriptionRes;
      try {
        this.prescriptionRes.data = data.filter(v => {
          if (v.id != id) {
            return v;
          }
        });
      } catch (error) {
        window.location.reload();
      }
    },
    godisabledShopList() {
      // 跳转到禁用列表
      this.$router.push('/shopManagement/disabledShop');
    },
    initData() {
      this.currentPage = 1;
      this.prescriptionRes = {};
      this.searchData = {
        storeName: '',
        prescriptionTotalStatus: ''
      };
    },
    search(data) {
      this.currentPage = 1;
      this.searchParam = data;
      let params = {
        pageNo: this.currentPage,
        pageSize: Constant.pageSize,
        ...this.searchParam
      };
      let self = this;
      Util.submitOnce(function () {
        self.fetchList(params);
      });
    },
    handleCurrentChange(val) {
      let params = {
        pageNo: val,
        pageSize: Constant.pageSize,
        isDelete: 1,
        ...this.searchParam
      };
      this.fetchList(params);
    },
    fetchList(param) {
      Fetch.get_store_page(param).then(
        res => {
          this.prescriptionRes = res;
        },
        () => {
          this.prescriptionRes = {};
        }
      );
    },
    selectChange(ids) {
      this.selectIds = ids;
    }
  }
};
</script>

<style lang="scss">
.tab-pre,
.el-breadcrumb {
  font-size: 12px;
  color: #999999;
  line-height: 40px;
}

.el-table th {
  background: #f7f7f7;
  color: #666;
}
// .el-pagination {
//   // margin-top: 22px;
//   text-align: center;
// }

.el-pagination__total,
.el-pagination__jump {
  color: #999;
}
</style>

<style lang="scss" scoped>
.title-area {
  overflow: hidden;
  // padding-bottom: 10px;

  .main-title {
    float: left;
    line-height: 40px;
  }
  .handler-area {
    overflow: hidden;
    .setting {
    }
    .add-story {
      // background: #ebb436;
      // &:hover {
      //   background: rgba(255, 195, 59, 1);
      // }
      // span {
      //   color: #fff;
      // }
    }
    .btn {
      width: 132px;
      height: 40px;
      float: right;
      line-height: 40px;
      text-align: center;
      margin-right: 16px;
      border-radius: 4px;
      cursor: pointer;
      span {
        font-size: 14px;
      }
    }
  }
  .cancle {
  }
  .submit {
  }
}
.list-content {
  background: #ffffff;
  border: 1px solid #f2f2f2;
  box-shadow: 0 4px 12px 0 #ededed;
  border-radius: 4px;
  padding: 16px;
  min-height: 600px;
  .listSearchArea {
    padding-bottom: 20px;
    &:after {
      content: '.';
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }
    .select_from_store_name {
      float: left;
    }
  }
}
.footer {
  overflow: hidden;
  display: flex;
  justify-content: center;
  position: relative;
  .sureJump {
    // float: left;
    width: 80px;
    height: 32px;
    // color: #1E8DFF;
    // background: #ffffff;
    // border: 1px solid #1E8DFF;
    border-radius: 3px;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
    margin-top: 20px;
    margin-left: 10px;
  }
  .disabled_page {
    position: absolute;
    display: flex;
    align-items: center;
    right: 20px;
    top: 30px;
    cursor: pointer;
  }
}
</style>
